module.exports = __webpack_public_path__ + "static/img/banner-1.cec52ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-1.jpg
// module id = Pb69
// module chunks = 1